import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

const EMPLOYEE_AUDIENCES = [
  'self',
  'all_employees_at_location',
  'all_employees_at_default_location',
  'all_employees_with_reservation',
  'all_employees_checked_in',
  'custom_employee_audience',
  'employees_without_phone_numbers',
];

export default Factory.extend({
  visitorAudience: () => faker.helpers.arrayElement('all_visitors_with_reservation', 'all_visitors_checked_in'),
  employeeAudience: () => faker.helpers.arrayElement(EMPLOYEE_AUDIENCES),
});
